export default __webpack_public_path__ + "media/images/react_icons/property/bath_products-e5c6dd037683107bb45a642baf2b9fbc.svg";